import { render } from "./InformationRectangle.vue?vue&type=template&id=59107d34&scoped=true"
import script from "./InformationRectangle.vue?vue&type=script&lang=js"
export * from "./InformationRectangle.vue?vue&type=script&lang=js"

import "./InformationRectangle.vue?vue&type=style&index=0&id=59107d34&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59107d34"]])

export default __exports__